// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `just codegen-experiment-function --experiment "xplat-computer-effort-ui" --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeBooleanFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
export const useXplatComputerEffortUiVariation = makeBooleanFlagValueHook('xplat-computer-effort-ui');
//# sourceMappingURL=useXplatComputerEffortUiVariation.js.map